import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ArrowRight, Sparkles } from "lucide-react";

const Hero = ({ onCTA }) => {
  const { t } = useTranslation();
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden border-b border-zinc-200"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/25e9688b-8d10-4224-b179-92764fdd13b3/images/e8b30ed6566a791ba62cd4f0e1fbe9407e6dfa6a7e40608ffde3813d4461d315.jpeg"
          alt=""
          className="absolute right-0 top-0 h-full w-full md:w-3/4 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white from-30% via-white/80 via-55% to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-28 md:pt-32 md:pb-40">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <div className="inline-flex items-center gap-2 border border-gold bg-white px-3 py-1.5 mb-8 glow-gold">
            <Sparkles className="w-3.5 h-3.5 text-gold" />
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-700">
              {t("hero.badge")}
            </span>
          </div>

          <h1 className="font-display font-black text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter text-zinc-950">
            {t("hero.title1")}{" "}
            <span className="relative inline-block">
              {t("hero.title2")}
              <span className="absolute -bottom-2 left-0 right-0 h-3 bg-[#4F46E5]/20 -z-10" />
            </span>
            <br />
            {t("hero.title3")}
            <br />
            <span className="text-[#4F46E5]">{t("hero.title4")}</span>
          </h1>

          <p className="mt-8 max-w-xl text-lg md:text-xl text-zinc-600 leading-relaxed">
            {t("hero.subtitle")}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={onCTA}
              className="group inline-flex items-center justify-center gap-2 bg-[#4F46E5] hover:bg-[#4338CA] text-white px-7 py-4 text-base font-semibold transition-all"
            >
              {t("hero.ctaPrimary")}
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
            <a
              href="/temario"
              target="_blank"
              rel="noreferrer"
              data-testid="hero-cta-whop"
              className="inline-flex items-center justify-center gap-2 border-[1.5px] border-zinc-900 bg-white text-zinc-900 px-7 py-4 text-base font-semibold hover:bg-zinc-900 hover:text-white transition-all"
            >
              {t("hero.ctaSecondary")}
            </a>
          </div>

          <div className="mt-14 flex flex-wrap items-center gap-x-10 gap-y-4 text-sm">
            <div className="flex items-center gap-3">
              <div className="flex -space-x-2">
                {[
                  "https://images.pexels.com/photos/12902865/pexels-photo-12902865.jpeg",
                  "https://images.pexels.com/photos/20752572/pexels-photo-20752572.jpeg",
                ].map((src) => (
                  <div
                    key={src}
                    className="w-9 h-9 rounded-full border-2 border-white overflow-hidden bg-zinc-200"
                  >
                    <img src={src} alt="" className="w-full h-full object-cover" />
                  </div>
                ))}
                <div className="w-9 h-9 rounded-full border-2 border-white bg-[#4F46E5] flex items-center justify-center text-white text-xs font-bold">
                  +1k
                </div>
              </div>
              <div>
                <div className="font-semibold text-zinc-900">{t("hero.students")}</div>
                <div className="text-zinc-500 text-xs">{t("hero.studentsSub")}</div>
              </div>
            </div>
            <div className="hidden sm:block w-px h-10 bg-zinc-300" />
            <div>
              <div className="font-semibold text-zinc-900">{t("hero.rating")}</div>
              <div className="text-zinc-500 text-xs">{t("hero.ratingSub")}</div>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="h-px gradient-line" />
    </section>
  );
};

export default Hero;
